'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../core/view');

var _view2 = _interopRequireDefault(_view);

var _controls = require('./controls.scss');

var _controls2 = _interopRequireDefault(_controls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ControlsView = function (_View) {
  _inherits(ControlsView, _View);

  function ControlsView(config) {
    _classCallCheck(this, ControlsView);

    var _this = _possibleConstructorReturn(this, (ControlsView.__proto__ || Object.getPrototypeOf(ControlsView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['controls-block'],
      'data-hook': 'controls-block',
      tabIndex: 0
    });

    _this.$wrapper = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['controls-wrapper'],
      tabIndex: 0
    });

    var background = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['gradient-background']
    });

    _this.$controlsContainer = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.controls,
      'data-hook': 'controls-container'
    });

    _this.$wrapper.append(background).append(_this.$controlsContainer);

    _this.$node.append(_this.$wrapper);

    _this._bindEvents();
    return _this;
  }

  _createClass(ControlsView, [{
    key: '_preventClickPropagation',
    value: function _preventClickPropagation(e) {
      e.stopPropagation();
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$controlsContainer[0].addEventListener('click', this._preventClickPropagation);
      this.$controlsContainer[0].addEventListener('mousemove', this._callbacks.onControlsBlockMouseMove);
      this.$controlsContainer[0].addEventListener('mouseleave', this._callbacks.onControlsBlockMouseOut);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$controlsContainer[0].removeEventListener('click', this._preventClickPropagation);
      this.$controlsContainer[0].removeEventListener('mousemove', this._callbacks.onControlsBlockMouseMove);
      this.$controlsContainer[0].removeEventListener('mouseleave', this._callbacks.onControlsBlockMouseOut);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'appendControlNode',
    value: function appendControlNode(node) {
      this.$controlsContainer.append(node);
    }
  }, {
    key: 'showControlsBlock',
    value: function showControlsBlock() {
      this.$wrapper.toggleClass(this.styleNames.activated, true);
    }
  }, {
    key: 'hideControlsBlock',
    value: function hideControlsBlock() {
      this.$wrapper.toggleClass(this.styleNames.activated, false);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$wrapper;
      delete this.$controlsContainer;
      delete this.$node;
    }
  }]);

  return ControlsView;
}(_view2.default);

ControlsView.extendStyleNames(_controls2.default);

exports.default = ControlsView;
//# sourceMappingURL=controls.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/controls.view.js
// module id = 1695
// module chunks = 1 2 3